import React from 'react';

export interface CacheApiContextType {
    getCachedValue: (prop: string, loadFnc: () => TODO_TYPEME) => TODO_TYPEME;
}
interface CachedValuesType {
    prop: string;
    results: TODO_TYPEME;
}
const CacheApiContext = React.createContext<CacheApiContextType | null>(null);

function CacheApiProvider(props: { children: JSX.Element }) {
    const cachedValues = React.useRef<CachedValuesType[]>([]);

    const getCachedValue = React.useCallback(
        async (prop: string, loadFnc: () => TODO_TYPEME) => {
            const found = cachedValues.current.find((x) => x.prop === prop);
            if (found) {
                return found.results;
            }
            const results = await loadFnc();
            cachedValues.current.push({ prop, results });
            return results;
        },
        [cachedValues]
    );

    const methods: CacheApiContextType = { getCachedValue };

    return <CacheApiContext.Provider value={methods} {...props} />;
}

export { CacheApiContext, CacheApiProvider };
